import { ReactElement } from 'react';
import styled from 'styled-components';

import { Portal } from '@dreryk/react-components';

const StyledPrescriptionsAdvertisementBox = styled(Portal.Container)`
   margin: 0 auto;
`;
StyledPrescriptionsAdvertisementBox.displayName = 'StyledPrescriptionsAdvertisementBox';

const PRESCRIPTIONS_ADVERTISEMENT_PORTAL_CONTAINER_ID = 'PRESCRIPTIONS_ADVERTISEMENT_PORTAL';

export const PrescriptionsAdvertisementBox = (): JSX.Element => (
   <StyledPrescriptionsAdvertisementBox
      id={PRESCRIPTIONS_ADVERTISEMENT_PORTAL_CONTAINER_ID}
      testId={'prescriptionsAdvertisement'}
   />
);

type PrescriptionsAdvertisementBoxPortalProps = {
   readonly children: ReactElement;
};

export const PrescriptionsAdvertisementBoxPortal = (props: PrescriptionsAdvertisementBoxPortalProps): JSX.Element => (
   <Portal containerId={PRESCRIPTIONS_ADVERTISEMENT_PORTAL_CONTAINER_ID}>{props.children}</Portal>
);
